<div class="mtm-breadcrumb-project">
  @if (breadcrumbPath) {
    <div class="mtm-breadcrumb-path d-flex align-items-center">
      @for (
        node of breadcrumbPath;
        track node?.id ?? $index;
        let index = $index;
        let last = $last;
        let first = $first;
        let count = $count
      ) {
        @if (
          !first &&
          ((!isCompactView && (shouldShowNode(index) || shouldShowEllipsis(index))) ||
            (isCompactView && index === count - 1))
        ) {
          <span class="d-flex align-items-center px-1">
            <i class="fa fa-chevron-right"></i>
          </span>
        }

        @if (shouldShowEllipsis(index)) {
          <div ngbDropdown class="d-inline-block" container="body">
            <span ngbDropdownToggle class="hidden-nodes mx-2 d-flex align-items-center" tabindex="0" role="button">
              <i class="fa fa-ellipsis-h"></i>
            </span>
            <div ngbDropdownMenu>
              @for (hiddenNode of getHiddenNodes(); track hiddenNode?.id ?? $index) {
                <button
                  ngbDropdownItem
                  class="d-block _1-line-text-ellipsis _500"
                  [title]="decodeNodeName(hiddenNode)"
                  (click)="onNodeClick(hiddenNode, $event)"
                  type="button">
                  {{ decodeNodeName(hiddenNode) }}
                </button>
              }
            </div>
          </div>
        }

        @if (shouldShowNode(index)) {
          <div
            class="mtm-breadcrumb-item d-flex align-items-center px-1"
            [class._500]="!last"
            [class._700]="last"
            [class.active]="last && !dropdownNodeStatusMap.get(node.id)">
            @if (node?.children?.length) {
              <div
                ngbDropdown
                class="d-flex align-items-center"
                [ngbDropdownAnchor]="node.id"
                container="body"
                [autoClose]="true"
                display="dynamic"
                (openChange)="onDropdownOpenChange(node.id, $event)">
                <div class="d-flex align-items-center">
                  <span
                    class="node-name py-1"
                    [title]="decodeNodeName(node)"
                    [class.project-root-node]="node.type === treeNodeType.ProjectRoot"
                    ngbDropdownToggle
                    tabindex="0"
                    role="button">
                    {{ decodeNodeName(node) }}
                  </span>
                  <div ngbDropdownMenu class="project-breadcrumb-dropdown-menu">
                    @for (child of node?.children; track child?.id ?? $index) {
                      @if (isSubsectionVersionNode(child) && shouldSkipVersionNode(child)) {
                        @for (grandchild of child.children; track grandchild?.id ?? $index) {
                          <button
                            class="d-block _1-line-text-ellipsis _500 py-1"
                            ngbDropdownItem
                            [title]="decodeNodeName(grandchild)"
                            (click)="onNodeClick(grandchild, $event)"
                            type="button">
                            {{ decodeNodeName(grandchild) }}
                          </button>
                        }
                      } @else {
                        <button
                          ngbDropdownItem
                          [title]="decodeNodeName(child)"
                          (click)="onNodeClick(child, $event)"
                          class="d-block _1-line-text-ellipsis _500 py-1"
                          [class.root-node]="
                            child.type === treeNodeType.ShareLinkRoot || child.type === treeNodeType.KpfRoot
                          "
                          type="button">
                          {{ decodeNodeName(child) }}
                        </button>
                      }
                    }
                  </div>
                </div>
                <svg
                  width="10"
                  height="8"
                  viewBox="0 0 7 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="ms-1"
                  aria-hidden="true">
                  <path
                    d="M3.17773 5.52783L0.146646 0.277831L6.20882 0.277832L3.17773 5.52783Z"
                    fill="black"
                    fill-opacity="0.5" />
                </svg>
              </div>
            } @else {
              <span
                class="d-block _1-line-text-ellipsis py-1"
                [title]="decodeNodeName(node)"
                (click)="onNodeClick(node, $event)"
                tabindex="0"
                role="button">
                {{ decodeNodeName(node) }}
              </span>
            }
          </div>
        }
      }
    </div>
  }
</div>
